// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import axios, { AxiosPromise } from 'axios';
import { authDelete, authGet, authPost, parseCamelCase, parseSnakeCase, authPut } from './util';
import { snakeCase } from 'change-case';
import { SupportType, questionnairePayload } from '../types/Model';
const baseURL = '/base';

export async function uploadFile(file: File) {
  const {
    uploadUrl,
    fileName,
  } = await getSignedUrl();

  console.log({ uploadUrl });

  const promise = axios.put(uploadUrl, file);

  return { fileName: fileName as string, upload: promise };
}

export async function getSignedUrl() {
  return await authGet(`${baseURL}/signedUrl`).then((data) => data?.data);
}

export async function getCommon() {
  return await authGet(`${baseURL}/common`).then((data) => parseCamelCase(data.data));
}

export const createSupport = (message: string, imagesUrls: string[], title: string, supportType: SupportType): AxiosPromise => {
  return authPost(`${baseURL}/problems`, parseSnakeCase({message, imagesUrls, supportType, title}));
};

export const GetSupports = (): AxiosPromise => {
  return authGet(`${baseURL}/problems`, {
    transformResponse: (data: any) => {
      return {
        list: parseCamelCase(data)
      }
    }
  }
  )
};

export const ReplySupport = (message: string, imagesUrls: string[], id: number): AxiosPromise => {
  return authPost(`${baseURL}/problems/${id}/replies`, parseSnakeCase({message, imagesUrls}));
};

export const UpdateReadSupport = (id: number): AxiosPromise => {
  return authPut(`${baseURL}/problems/${id}/replies`);
};

export const UpdateSupportStatus = (id: number): AxiosPromise => {
  return authPut(`${baseURL}/problems/${id}/status`);
};

export const createFavorites = (onlineCourseId?: number, labId?: number): AxiosPromise => {
  return authPost(`${baseURL}/favorite`, parseSnakeCase({ onlineCourseId, labId }));
};

export const deleteFavorites = (id: number, condition: string): AxiosPromise => {
  return authDelete(`/base/favorite/${snakeCase(condition)}/${id}`, {
    responseType: 'json'
  });
};

export const sendActive = (duration: number, organizationId: number | null, sourceFrom: string, sourceId: number, vodId: number): AxiosPromise => {
  return authPost(`${baseURL}/activeUser`, parseSnakeCase({ duration, organizationId, sourceFrom, sourceId, vodId }))
};

export const questionnaire = (payload: questionnairePayload): AxiosPromise => {
  return authPost(`${baseURL}/questionnaire`, parseSnakeCase(payload))
};

export const dashboardDetail = (orgId: number, type: string, id: any): AxiosPromise => {
  const query = `?type=${type}`;

  return authGet(`${baseURL}/${orgId}/dashboard/${id}/detail${query}`, {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};

export const postDashboardDownloadDetail = (orgId: number, id: number, type: string, category: string, name?: string): AxiosPromise => {

  return authPost(`${baseURL}/${orgId}/dashboard/downloadHistory`, parseSnakeCase({
    id,
    type,
    category,
    name
  }), {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};
